import {
  buildBasicInformationErrors,
  hasBasicInformationDraftErrors,
  hasBasicInformationErrors,
} from '../ui/create-template/basic-information/lib/buildBasicInformationErrors';

function buildValidationErrors({
  channelKey,
  form,
  saveAttempt,
  publishAttempt,
  draftAttempt,
  touchState = null,
  dayOptionalByRow = [],
}) {
  return buildBasicInformationErrors({
    channel: channelKey,
    saveAttempt,
    publishAttempt,
    draftAttempt,
    templateName: form?.templateName,
    subjects: form?.subjects,
    type: form?.type,
    selectedCampaignIds: form?.selectedCampaignIds,
    triggerId: form?.triggerId,
    sendConditions: form?.sendConditions,
    touched: touchState?.touched ?? null,
    subjectsTouched: touchState?.subjectsTouched ?? null,
    sendConditionsTouched: touchState?.sendConditionsTouched ?? null,
    dayOptionalByRow,
  });
}

export function hasTemplateNameBlockingError(errors) {
  return (
    String(errors?.templateNameMaxError ?? '').trim().length > 0 ||
    String(errors?.templateNameRequiredError ?? '').trim().length > 0
  );
}

export function buildTemplateValidationErrorsForAttempt({
  channelKey,
  form,
  isPublish = true,
  dayOptionalByRow = [],
}) {
  return buildValidationErrors({
    channelKey,
    form,
    saveAttempt: 1,
    publishAttempt: isPublish,
    draftAttempt: !isPublish,
    dayOptionalByRow,
  });
}

export function buildTemplateValidationState({
  channelKey,
  form,
  hasTriedSave = false,
  hasTriedPublish = false,
  touchState = null,
  dayOptionalByRow = [],
}) {
  const draftValidationErrors = buildValidationErrors({
    channelKey,
    form,
    saveAttempt: hasTriedSave || hasTriedPublish ? 1 : 0,
    publishAttempt: false,
    draftAttempt: hasTriedSave || hasTriedPublish,
    touchState,
    dayOptionalByRow,
  });

  const publishValidationErrors = buildValidationErrors({
    channelKey,
    form,
    saveAttempt: hasTriedPublish ? 1 : 0,
    publishAttempt: hasTriedPublish,
    draftAttempt: false,
    touchState,
    dayOptionalByRow,
  });

  return {
    hasDraftBlockingErrors: hasBasicInformationDraftErrors(draftValidationErrors),
    hasPublishBlockingErrors: hasBasicInformationErrors(publishValidationErrors),
    hasTemplateNameBlockingError: hasTemplateNameBlockingError(draftValidationErrors),
    hasSendConditionsBlockingError:
      String(draftValidationErrors?.sendConditionsRequiredError ?? '').trim().length > 0,
  };
}
